import { RowWithParts } from '@websky/core/src/SeatMap/components/SeatMap/utils';

export const getServicesMinPrice = (row: RowWithParts) => {
	let minPrice: number = null;

	row.parts.forEach(part => {
		if (part.service.seatService && (!minPrice || part.service.minPrice.amount < minPrice)) {
			minPrice = part.service.minPrice.amount;
		}
	});

	return minPrice;
};
